export default {
  computed: {
    tagSlugs () {
      this.tags = this.tags || []

      const slugs = this.tags.map((tag) => tag.slug)

      return slugs
    }
  },

  created () {
    this.$on('tagAdded', this.addTag)
    this.$on('tagRemoved', this.removeTag)
  },

  methods: {
    addTag (tag) {
      this.tags.push(tag)
    },

    tagPos (tag) {
      return this.tags.indexOf(tag)
    },

    removeTag (tag) {
      const tagPos = this.tagPos(tag)

      this.tags.splice(tagPos, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/TagMixin.js